const mainGreen = '#326A32';

const mainHeaderColor = 'rgba(51, 51, 51, 1)';

const mainTitleColor ='rgba(0, 0, 0, 1)';

const mainTextColor = 'rgba(0, 0, 0, 1)';

const shadow = '0px 4px 8px 0px rgba(0, 0, 0, 0.12)'

const shadowSecond =  '0px 8px 16px 0px rgba(0, 0, 0, 0.08)';

export {shadow,mainGreen, mainHeaderColor, mainTitleColor, mainTextColor, shadowSecond}
